import React, { useContext, useState } from 'react';
import { usePoll } from '../data/fetch/useFetch';
import { classIf, filterBetsByNumberOfOdds, filtraParametriche, getBetDescription, getConfiguration, iconCategoryCssClass, iconSportCssClass } from '../data/utils';
import { parseLiveData } from '../data/parseLiveData';
import Jersey from '../data/jerseys/Jersey';
import Odd from './Odd';
import { getLabel } from '../data/labels';
import LiveScores from './LiveScores';
import LiveContext from '../contexts/LiveContext';
import { getFirstLine } from '../common/UOBox';
import LiveMinutes from './LiveMinutes';

export default function LiveMatches() {
    const conf = getConfiguration();
    const liveContext = useContext(LiveContext);
    const [sportId, setSportId] = useState(0);

    const [, , data] = usePoll(conf.api.getMenuLiveGenerale, { sportId }, (data) =>
        data ? parseLiveData(data) : null
    );

    if (data == null) {
        return null;
    }

    let currentSport = data.sport[0];
    if (sportId !== 0 && data.sportById[sportId]) {
        currentSport = data.sportById[sportId];
    }

    const matches = [];
    currentSport.categories.forEach(c => {
        if (c.id === 0) {
            return;
        }
        c.tournaments.forEach(t =>
            matches.push(...t.events)
        )
    });

    const betsDescs = [];
    const renderMatches = matches.slice(0, 5).map((m, i) => {
        const categoryIcon = iconCategoryCssClass(m.sportRef, m.categoryRef, m.categoryIcon);

        function open(match) {
            liveContext.setMatchData({
                sportId: match.sportRef,
                countryId: match.categoryRef,
                tournamentId: match.tournamentRef,
                matchId: match.id
            }, true);
            window.openSection('live-match');
        }

        let bets = filtraParametriche(m.bets);
        bets = filterBetsByNumberOfOdds(bets);

        return (
            <React.Fragment key={m.uniqueId}>
                <div className="match">
                    <div className="left-section">
                        <div className="time">
                            <LiveMinutes score={m.score} />
                        </div>
                        <div className="info">
                            <div className="tournament-desc">
                                <div className={"sport-icon " + categoryIcon} />
                                <span>{m.tournamentDesc}</span>
                            </div>
                            <div className="teams" onClick={() => open(m)}>
                                <div className="team-home">
                                    <Jersey data={m.jerseys?.[0]} type={'home'} sportRef={m.sportRef} />
                                    <span>{m.team1}</span>
                                </div>
                                <div className="team-away">
                                    <Jersey data={m.jerseys?.[1]} type={'away'} sportRef={m.sportRef} />
                                    <span>{m.team2}</span>
                                </div>
                            </div>
                        </div>
                        <div className="live-scores">
                            {m.score &&
                                <LiveScores data={m.score} />
                            }
                        </div>
                    </div>
                    <div className="odds">
                        {bets.map((b, betIndex) => {
                            const isParametrica = b.parametrica;
                            if (isParametrica) {
                                b = getFirstLine(m.betsById.get(b.id));
                            }

                            const oddsDescs = [];
                            const renderedOdds = [];
                            b.odds.forEach(odd => {
                                if (i === 0) {
                                    oddsDescs.push(
                                        <span key={odd.uniqueId} className="odd-desc">{odd.desc}</span>
                                    );
                                }
                                renderedOdds.push(
                                    <Odd key={odd.uniqueId} data={odd} />
                                );
                            });
                                    
                            let nCols = b.odds.length;
                            if (isParametrica) {
                                nCols++;
                            }

                            const isEven = betIndex % 2 === 0;
                            const hideable = betIndex > 1;

                            if (i === 0) {
                                betsDescs.push(
                                    <div key={b.id} className="bets-header-item" data-odds={nCols} data-hideable={hideable}>
                                        <div className={"bet-desc-container" + classIf(isEven, 'lighter')}>
                                            <span className="bet-desc">{getBetDescription(b, true, currentSport.id)}</span>
                                        </div>
                                        <div className="odds-descs">
                                            {isParametrica &&
                                                <span className="odd-desc">{b.handicapTableDesc}</span>
                                            }
                                            {oddsDescs}
                                        </div>
                                    </div>
                                );
                            }

                            return (
                                <React.Fragment key={betIndex}>
                                    {isParametrica &&
                                        <div className={"bet" + classIf(isEven, 'lighter')} data-hideable={hideable}>
                                            <span className="odd">{b.handicapDesc !== '' && b.handicapDesc !== '0' ? b.handicapDesc : <i className="fa fa-lock"></i>}</span>
                                        </div>
                                    }
                                    <div className={"bet" + classIf(isEven, 'lighter')} data-hideable={hideable}>
                                        {renderedOdds}
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                </div>
            </React.Fragment>
        );
    });

    return (
        <>
            <div className="section-title">
                <span className="title">{getLabel('menu.live_match')}</span>
                <div className="sport-switcher">
                    {data.sport.map(sport => {
                        const id = sport.id;
                        function handleClick() {
                            setSportId(id);
                        }

                        const desc = data.sportById[id].descrizione;
                        const icoSport = iconSportCssClass(sport.id, sport.iconClass);

                        return (
                            <div key={id} className={"selection-item" + classIf(currentSport.id === id, 'active')} onClick={handleClick}>
                                <div className={"icona-sport ico-sport " + icoSport}></div>
                                <span className="selection-item-desc">{desc}</span>
                                <div className="counter">
                                    {sport.eventsCount}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="live-matches">
            <div className="matches-container">
                    <div className="bets-header">
                        <div className="info-column-header">
                            <div className="sport-desc">{currentSport.desc}</div>
                            <div className="sub-header">
                                <div className="time"></div>
                                <div className="info"></div>
                            </div>
                        </div>
                        <div className="bets-header-descs">{betsDescs}</div>
                    </div>
                    {renderMatches}
                </div>
            </div>
            <div className="cta" onClick={() => window.openSection('live-suite')}>
                <span className="desc">{getLabel('prematch_page.torneo.outrights.toggle_button.show_all')}</span>
                <div className="arrow" data-type="right"></div>
            </div>
        </>
    );
}
